import React, { Component } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

import { BeamPocketSettings } from '@paragon/contract-library';
import { DistanceField, NumericField } from '@paragon/material';

import { InteriorConditionSettingsPropertiesProps } from './InteriorConditionSettingsPropertiesProps';

type Props = InteriorConditionSettingsPropertiesProps<BeamPocketSettings>;

export class BeamPocketSettingsProperties extends Component<Props> {
  createSubmitHandler =
    <K extends keyof BeamPocketSettings>(key: K) =>
    (value: BeamPocketSettings[K]) => {
      this.props.onChange({ ...this.props.value, [key]: value });
    };

  render() {
    const { value } = this.props;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <DistanceField
            sx={[
              value.distanceFromLeft === 0
                ? { m: 1, width: '30%', fieldSet: { borderColor: 'brand.orange' } }
                : { m: 1, width: '30%' },
            ]}
            label="Distance From Left"
            value={value.distanceFromLeft}
            onSubmit={this.createSubmitHandler('distanceFromLeft')}
          />

          <DistanceField
            sx={{ m: 1, width: '30%' }}
            label="Bearing Width"
            value={value.bearingWidth}
            onSubmit={this.createSubmitHandler('bearingWidth')}
          />

          <DistanceField
            sx={{ m: 1, width: '30%' }}
            label="Pocket Width"
            value={value.pocketWidth}
            onSubmit={this.createSubmitHandler('pocketWidth')}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <DistanceField
            sx={{ m: 1, width: '30%' }}
            label="Pocket Height"
            value={value.pocketHeight}
            onSubmit={this.createSubmitHandler('pocketHeight')}
          />

          <NumericField
            sx={{ m: 1, width: '30%' }}
            label="Left Verticals Count"
            value={value.leftVerticalsCount}
            onSubmit={this.createSubmitHandler('leftVerticalsCount')}
          />

          <NumericField
            sx={{ m: 1, width: '30%' }}
            label="Right Verticals Count"
            value={value.rightVerticalsCount}
            onSubmit={this.createSubmitHandler('rightVerticalsCount')}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value.bottomChordCutOut}
                onChange={(event) => this.createSubmitHandler('bottomChordCutOut')(event.target.checked)}
              />
            }
            label="Bottom Chord Cut Out"
          />
        </Box>
      </Box>
    );
  }
}
